/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCountryDto } from './GetCountryDto';
import {
    GetCountryDtoFromJSON,
    GetCountryDtoFromJSONTyped,
    GetCountryDtoToJSON,
} from './GetCountryDto';
import type { GetEmailAddressDto } from './GetEmailAddressDto';
import {
    GetEmailAddressDtoFromJSON,
    GetEmailAddressDtoFromJSONTyped,
    GetEmailAddressDtoToJSON,
} from './GetEmailAddressDto';

/**
 * 
 * @export
 * @interface GetSalesInvoiceDtoRecipientClient
 */
export interface GetSalesInvoiceDtoRecipientClient {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    shortname: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    pesel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    place: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    street: string;
    /**
     * 
     * @type {GetCountryDto}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    country: GetCountryDto;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    numbers: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    flat: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    isRelated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    internal: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    dealGroupNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    notToSymphony: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    signContractBlock: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    notSendMailFVS: boolean;
    /**
     * 
     * @type {Array<GetEmailAddressDto>}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    emailAddresses?: Array<GetEmailAddressDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    overduePaymentReminder: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    paymentRequest: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    paymentRequestKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    paymentRequestBlockKRD: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    interest: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    language: GetSalesInvoiceDtoRecipientClientLanguageEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    hasActivePurchaser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDtoRecipientClient
     */
    hasActivePosition?: boolean;
}


/**
 * @export
 */
export const GetSalesInvoiceDtoRecipientClientLanguageEnum = {
    Pl: 'PL',
    En: 'EN'
} as const;
export type GetSalesInvoiceDtoRecipientClientLanguageEnum = typeof GetSalesInvoiceDtoRecipientClientLanguageEnum[keyof typeof GetSalesInvoiceDtoRecipientClientLanguageEnum];


/**
 * Check if a given object implements the GetSalesInvoiceDtoRecipientClient interface.
 */
export function instanceOfGetSalesInvoiceDtoRecipientClient(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "shortname" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "postcode" in value;
    isInstance = isInstance && "place" in value;
    isInstance = isInstance && "street" in value;
    isInstance = isInstance && "country" in value;
    isInstance = isInstance && "numbers" in value;
    isInstance = isInstance && "flat" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "isRelated" in value;
    isInstance = isInstance && "internal" in value;
    isInstance = isInstance && "dealGroupNumber" in value;
    isInstance = isInstance && "notToSymphony" in value;
    isInstance = isInstance && "signContractBlock" in value;
    isInstance = isInstance && "notSendMailFVS" in value;
    isInstance = isInstance && "overduePaymentReminder" in value;
    isInstance = isInstance && "paymentRequest" in value;
    isInstance = isInstance && "paymentRequestKRD" in value;
    isInstance = isInstance && "paymentRequestBlockKRD" in value;
    isInstance = isInstance && "interest" in value;
    isInstance = isInstance && "language" in value;

    return isInstance;
}

export function GetSalesInvoiceDtoRecipientClientFromJSON(json: any): GetSalesInvoiceDtoRecipientClient {
    return GetSalesInvoiceDtoRecipientClientFromJSONTyped(json, false);
}

export function GetSalesInvoiceDtoRecipientClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoiceDtoRecipientClient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'shortname': json['shortname'],
        'name': json['name'],
        'nip': !exists(json, 'nip') ? undefined : json['nip'],
        'pesel': !exists(json, 'pesel') ? undefined : json['pesel'],
        'postcode': json['postcode'],
        'place': json['place'],
        'street': json['street'],
        'country': GetCountryDtoFromJSON(json['country']),
        'numbers': json['numbers'],
        'flat': json['flat'],
        'active': json['active'],
        'isRelated': json['isRelated'],
        'internal': json['internal'],
        'dealGroupNumber': json['dealGroupNumber'],
        'notToSymphony': json['notToSymphony'],
        'signContractBlock': json['signContractBlock'],
        'notSendMailFVS': json['notSendMailFVS'],
        'emailAddresses': !exists(json, 'emailAddresses') ? undefined : (json['emailAddresses'] === null ? null : (json['emailAddresses'] as Array<any>).map(GetEmailAddressDtoFromJSON)),
        'overduePaymentReminder': json['overduePaymentReminder'],
        'paymentRequest': json['paymentRequest'],
        'paymentRequestKRD': json['paymentRequestKRD'],
        'paymentRequestBlockKRD': json['paymentRequestBlockKRD'],
        'interest': json['interest'],
        'language': json['language'],
        'hasActivePurchaser': !exists(json, 'hasActivePurchaser') ? undefined : json['hasActivePurchaser'],
        'hasActivePosition': !exists(json, 'hasActivePosition') ? undefined : json['hasActivePosition'],
    };
}

export function GetSalesInvoiceDtoRecipientClientToJSON(value?: GetSalesInvoiceDtoRecipientClient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'shortname': value.shortname,
        'name': value.name,
        'nip': value.nip,
        'pesel': value.pesel,
        'postcode': value.postcode,
        'place': value.place,
        'street': value.street,
        'country': GetCountryDtoToJSON(value.country),
        'numbers': value.numbers,
        'flat': value.flat,
        'active': value.active,
        'isRelated': value.isRelated,
        'internal': value.internal,
        'dealGroupNumber': value.dealGroupNumber,
        'notToSymphony': value.notToSymphony,
        'signContractBlock': value.signContractBlock,
        'notSendMailFVS': value.notSendMailFVS,
        'emailAddresses': value.emailAddresses === undefined ? undefined : (value.emailAddresses === null ? null : (value.emailAddresses as Array<any>).map(GetEmailAddressDtoToJSON)),
        'overduePaymentReminder': value.overduePaymentReminder,
        'paymentRequest': value.paymentRequest,
        'paymentRequestKRD': value.paymentRequestKRD,
        'paymentRequestBlockKRD': value.paymentRequestBlockKRD,
        'interest': value.interest,
        'language': value.language,
        'hasActivePurchaser': value.hasActivePurchaser,
        'hasActivePosition': value.hasActivePosition,
    };
}

